import { render, staticRenderFns } from "./studyplan-list.vue?vue&type=template&id=e828a810&scoped=true"
import script from "./studyplan-list.vue?vue&type=script&lang=js"
export * from "./studyplan-list.vue?vue&type=script&lang=js"
import style0 from "./studyplan-list.vue?vue&type=style&index=0&id=e828a810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e828a810",
  null
  
)

export default component.exports